<template>
  <div class="content">
    <div class="title">单项目进度报表</div>
    <div class="report-column">
      <div class="search-column">
        <div style="flex-basis: 200px;">
          项目名称
        </div>
        <el-input></el-input>
        <div style="flex-basis: 200px;">项目阶段
        </div>
        <el-input></el-input>
        <el-button type="primary" icon="el-icon-search">搜索</el-button>
        <el-button>重置</el-button>
      </div>
      <div class="status-list">

      </div>
    </div>
    <div class="echart-content">
      <div class="echart-item">
        <div class="chart-title">
          每日完成任务量
        </div>
        <div class="chart" id="taskCompelete">
        </div>
      </div>
      <div class="echart-item">
        <div class="chart-title">
          概览报表
        </div>
        <div style="padding: 15px;">
          <div class="task-column">
            <div v-for="item in taskList" style="width: 20%;">
              <div style="font-weight: 600;"> {{ item.name }}</div>
              <div style="  margin: 15px 0;"> {{ item.num }}</div>
              <el-progress :percentage='item.complete' :color="item.color"></el-progress>
            </div>
          </div>
          <div class="task-column">
            <div v-for="item in taskList2" style="width: 20%;">
              <div style="font-weight: 600;"> {{ item.name }}</div>
              <div style="  margin: 15px 0;"> {{ item.num }}</div>
              <el-progress :percentage='item.complete' :color="item.color"></el-progress>
            </div>
          </div>
        </div>
      </div>
      <div class="echart-item">
        <div class="chart-title">
          任务燃尽图
        </div>
        <div class="chart" id="taskTaskBurnDown">
        </div>
      </div>
      <div class="echart-item">
        <div class="chart-title">
          项目进展走势
        </div>
        <div class="chart" id="projectDebriefing">
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import * as echarts from 'echarts';
import { setBaseOptions, taskCompeleteEntries, taskTaskBurnDownEntries, projectDebriefingEntries } from './options'
export default {
  data() {
    return {
      taskList: [
        { name: '任务总数', num: 111, complete: 89, color: '#409eff' },
        { name: '已完成', num: 21, complete: 23, color: '#67c23a' },
        { name: '未完成', num: 90, complete: 20, color: '#e6a23c' },
        { name: '已逾期', num: 20, complete: 20, color: '#f56c6c' },
      ],
      taskList2: [
        { name: '待认领', num: 21, complete: 23, color: '#409eff' },
        { name: '按时完成', num: 6, complete: 2, color: '#67c23a' },
        { name: '今日到期', num: 0, complete: 0, color: '#e6a23c' },
        { name: '逾期完成', num: 5, complete: 9, color: '#f56c6c' },
      ]
    }
  },
  methods: {
    setDataInit() {
      const taskCompelete = setBaseOptions();
      // const op = taskCompelete.getOptions();
      taskCompelete.series = taskCompeleteEntries;
      this.getEchartInit({ domId: 'taskCompelete', option: taskCompelete });

      const taskTaskBurnDown = setBaseOptions();
      taskTaskBurnDown.series = taskTaskBurnDownEntries;
      this.getEchartInit({ domId: 'taskTaskBurnDown', option: taskTaskBurnDown });

      const projectDebriefing = setBaseOptions();
      projectDebriefing.series = projectDebriefingEntries;
      this.getEchartInit({ domId: 'projectDebriefing', option: projectDebriefing });


    },
    getEchartInit({ domId, option }) {
      var chartDom = document.getElementById(domId);
      var myChart = echarts.init(chartDom);
      option && myChart.setOption(option);
    }
  },
  mounted() {
    this.setDataInit()
  },
}
</script>

<style scoped>
.content {
  padding: 25px;
  padding-top: 5px;
}

.title {
  margin: 10px auto;
  font-size: 1.4em;
  font-weight: 600;
  text-align: left;
}

.chart-title {
  margin: 6px 15px;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  padding: 6px;
  width: 100%;
  border-bottom: 1px solid #fefefe;
}

.report-column {
  /* width: 600px; */
  margin: 15px auto;
  display: flex;
  gap: 1em
}

.search-column {
  display: flex;
  width: 800px;
  font-size: 12px;
  gap: 0.6em;
  align-items: center;
}

.echart-content {
  display: flex;
  flex-wrap: wrap;
  gap: 10px
}

.echart-item {
  width: 48%;
  height: 300px;
  border: 1px solid #e0e0e0;
}

.chart {
  width: 100%;
  height: 260px;
  /* border: 1px solid salmon; */
}

.task-column {
  display: flex;
  width: 100%;
  justify-content: space-around;
  font-size: 12px;
  margin: 15px 30px;
}
</style>